const { TYPES_CAR } = require('./TYPES_CAR');

module.exports = {
  TYPES_CAR,
};
